var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogoDay = function SvgLogoDay(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 55,
    viewBox: "115 9 180 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 55,
    viewBox: "0 0.416 77 54.169",
    fill: "#e30185",
    x: 191,
    y: 9,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 55,
    viewBox: "0.376 0.757 75.871 53.375",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M76.247 43.603V32.39a49.122 49.122 0 0 1-.111-5.96c.03-.806.07-1.611.11-2.416v-8.796c-.081-.415-.24-.805-.58-1.073-.696-.552-1.786-.661-2.631-.773-1.058-.141-2.115-.26-3.17-.415a296.67 296.67 0 0 1-7.18-1.125c-2.423-.418-4.818-.96-7.234-1.415-2.116-.398-4.232-.834-6.37-1.094-1.522-.186-3.18-.364-4.561-1.104l-25.832-4.57c-.728-.092-1.452-.198-2.174-.312-1.659-.261-3.311-.562-4.972-.818-1.386-.215-2.798-.302-4.166-.62-1.198-.278-2.378-.635-3.582-.884L2.749.83C1.97.724 1.173.707.437.964.415.972.396.974.376.979v4.235c.024.17.048.34.07.512.132.971.163 1.909.136 2.889a76.085 76.085 0 0 1-.206 3.664v14.374c.054.497.102.995.125 1.495.052 1.11-.026 2.224-.125 3.33v16.774c.162.759.259 1.522.272 2.308.011.678-.031 1.359.023 2.036.037.46.143.92.501 1.213.183.148.4.25.63.323l9.036-1.218c1.928-.614 3.855-1.26 5.861-1.557 2.537-.376 5.099-.376 7.656-.448.641-.018 1.282-.041 1.924-.077l6.423-.866c2.359-.422 4.715-.881 7.084-1.258 1.441-.23 2.894-.26 4.35-.284l31.948-4.308c.057-.171.113-.341.163-.513z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.23 0 0.54 1",
    fill: "#fff",
    x: 212,
    y: 19,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.076 0.687 0.057 0.106",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.076.687l.029.106C.115.755.12.736.133.698A1.06 1.06 0 0 1 .076.687z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.193 0 0.614 1",
    fill: "#fff",
    x: 211,
    y: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.265 0.818 0.056 0.091",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.32.83L.266.818l.024.09L.32.83z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.255 0 0.49 1",
    fill: "#fff",
    x: 243,
    y: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.857 0.229 0.064 0.13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.92.289L.888.229C.876.249.853.27.858.288c.008.026.035.048.053.07l.01-.07z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.102 0 0.797 1",
    fill: "#fff",
    x: 241,
    y: 27,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.113 0.137 0.076 0.095",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.189.21L.17.138C.15.144.123.144.115.16.108.175.124.207.13.232L.189.21z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.173 0 0.654 1",
    fill: "#fff",
    x: 245,
    y: 29,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.622 0.272 0.045 0.069",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.667.312L.624.272.622.34.667.312z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.21 0 0.581 1",
    fill: "#fff",
    x: 222,
    y: 27,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.89 0.472 0.047 0.081",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.919.472l-.03.064.048.017L.919.472z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.23 0 0.54 1",
    fill: "#fff",
    x: 212,
    y: 19,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.076 0.687 0.057 0.106",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.076.687c.022.005.034.007.057.01L.105.794.075.687z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.193 0 0.614 1",
    fill: "#fff",
    x: 211,
    y: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.265 0.818 0.056 0.091",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.32.83L.29.909.265.818.32.83z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 45,
    viewBox: "0.44 0 20.119 45",
    fill: "#fff",
    x: 195,
    y: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 45,
    viewBox: "0.443 0.384 19.667 43.988",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M19.99 32.777c-.034-.168 0-.37.014-.552.08-1.117.166-2.197-.163-3.232-.06-.19-.048-.42-.061-.63-.019-.318-.013-.638-.048-.95-.146-1.287-.038-2.553-.097-3.806-.005-.1.019-.201.027-.302.079-.971-.107-1.956.046-2.912.005-.03-.012-.067-.013-.1l-.085-2.131c-.009-.237-.006-.476-.026-.714-.047-.578-.126-1.159-.157-1.744-.058-1.142-.146-2.292-.346-3.474-.107-.631-.12-1.283-.13-1.947-.02-1.468-.14-2.994-.222-4.583a1.508 1.508 0 0 0-.056-.354c-.029-.096-.06-.21-.1-.3a.692.692 0 0 0-.148-.561v-.237c0-.23.04-.502-.078-.71-.134-.233-.4-.281-.638-.347a37.115 37.115 0 0 0-.717-.193 38.506 38.506 0 0 0-2.097-.474c-.228-.044-.508-.14-.74-.12-.146.014-.313.073-.38.219-.136.295-.154.659-.212.979a.55.55 0 0 0 .007.208c-.296.569-.36 1.205-.466 1.833a553.341 553.341 0 0 1-1.161 6.632 563.96 563.96 0 0 1-1.08 5.743c-.057-.165-.109-.332-.175-.495a303.237 303.237 0 0 0-1.747-6.624L7.61 6.002a.4.4 0 0 0 .007-.253c-.41-1.378-.79-2.763-1.142-4.156a.436.436 0 0 0-.307-.308A55.06 55.06 0 0 0 1.427.43C1.156.393.859.313.636.524.29.85.476 1.499.662 1.938H.66a.577.577 0 0 0-.054.118.192.192 0 0 0 .015.163c0 .006-.004.01-.004.017l.042 16.11c.013 5.344.012 10.688.044 16.032.014 2.372.07 4.745.229 7.112-.055.132-.091.269-.092.416.022.345.014.69-.021 1.035a.824.824 0 0 0 .095.424c.002.009.008.016.01.025l.003.044c.01.14.027.28.046.42.019.139.04.279.143.384.182.185.449.153.667.057.093-.041.174-.101.262-.15l.042-.022c.03.007.055.019.087.022.432.027.91-.08 1.339-.135.89-.115 1.775-.268 2.65-.463.398-.09.63-.233.628-.671-.001-.133-.007-.266-.011-.4a.455.455 0 0 1 .1.035c.005-.094.012-.188.023-.282-.039-.063-.087-.122-.135-.184-.011-.271-.024-.542-.034-.812a.206.206 0 0 0-.108-.179c.155-1.567.202-5.571.194-6.481-.004-.49-.057-.974-.061-1.454-.01-1.162-.268-2.308.018-3.416.026-.1.006-.234-.01-.347-.176-1.221.035-2.452-.228-3.64-.054-.24 0-.52.011-.78.01-.224.042-.445.042-.667.003-1.378-.002-2.741.002-4.101 0-.133-.006-.31.183-.316.159.579.362 1.158.468 1.76.093.533.419.905.516 1.37.109.519.051 1.09.206 1.632.23.804.441 1.62.64 2.445.358 1.469.71 2.958 1.043 4.49.255 1.172.373 1.363 1.398 1.165.106-.021.209-.085.312-.14.33-.174.653-.41.993-.514.389-.121.547-.465.599-.953.06-.565.09-1.13.151-1.682.07-.659.04-1.34.31-1.928.078-.172.062-.424.089-.637.05-.393.09-.788.152-1.172.139-.87.297-1.722.433-2.575.14-.89.249-1.783.402-2.658.058-.334.123-.664.188-.994a71.61 71.61 0 0 0-.062 2.78c.002 2.122.326 4.225.421 6.342.189 4.232-.404 8.462-.08 12.692a.68.68 0 0 0-.06.422 2.067 2.067 0 0 0-.055.309c-.031.366.229.67.604.668.156-.001.278-.06.42-.105a1.4 1.4 0 0 1 .379-.061c.303-.014.605-.016.907-.043.63-.058 1.256-.164 1.878-.277.352-.063.653-.207.683-.609.025-.321-.002-.655-.004-.977-.001-.031-.012-.054-.018-.082a.629.629 0 0 0 .15-.411c.021-1.215.04-2.43.062-3.643.006-.095.013-.178.019-.235.135-1.194.307-2.326.069-3.454zm-9.95-15.788c-.034-.154-.073-.307-.107-.461-.07-.321-.131-.643-.193-.964l.09.34c.094.362.182.725.273 1.088a.718.718 0 0 0-.062-.003z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 3,
    viewBox: "0.759 0 0.481 3",
    fill: "#fff",
    x: 244,
    y: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 3,
    viewBox: "0.902 0.747 0.356 2.217",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M1.14.747c.183.698.1 1.323.091 1.94a.393.393 0 0 1-.135.277C.922 2.208.746 1.43 1.14.747z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0 0.038 1 1.923",
    fill: "#fff",
    x: 235,
    y: 36,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.314 0.08 0.503 0.967",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.817 1.032C.449.87.322.565.314.08c.373.277.44.618.494.967l.009-.015z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.45 0 0.1 1",
    fill: "#fff",
    x: 245,
    y: 28,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.277 0.269 0.073 0.727",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.277.986V.269L.35.28v.716L.277.986z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.259 0 0.482 1",
    fill: "#fff",
    x: 241,
    y: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.223 0.372 0.198 0.41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.42.546C.4.615.38.7.344.765.326.793.263.778.223.782.231.674.229.562.251.46.259.418.319.4.357.372l.064.174z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 1,
    viewBox: "0.584 0 0.832 1",
    fill: "#fff",
    x: 245,
    y: 31,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 1,
    viewBox: "0.781 0.12 0.249 0.299",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.78.26L.937.12c.033.06.08.12.093.184C1.035.34.986.38.962.419A29.655 29.655 0 0 0 .78.26z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.214 0 0.571 1",
    fill: "#fff",
    x: 238,
    y: 34,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.643 0.071 0.082 0.143",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.725.152L.684.214C.67.192.639.16.644.15.658.12.686.097.709.07l.016.08z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.129 0 0.742 1",
    fill: "#fff",
    x: 241,
    y: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.565 0.154 0.138 0.186",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.6.154c.034.034.072.064.1.104C.709.273.696.34.688.34.648.34.606.325.565.316L.6.154z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.255 0 0.49 1",
    fill: "#fff",
    x: 243,
    y: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.857 0.229 0.064 0.13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.92.289C.919.312.916.336.91.359.894.336.867.314.859.288.853.27.876.248.887.228c.01.02.023.041.034.06z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0 0.158 1 1.684",
    fill: "#fff",
    x: 240,
    y: 33,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.358 0.884 0.094 0.159",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.452.957l-.068.086C.374 1.018.352.988.359.97.372.936.401.912.424.884l.028.073z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.102 0 0.797 1",
    fill: "#fff",
    x: 241,
    y: 27,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.113 0.137 0.076 0.095",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.189.21l-.06.022C.125.207.109.175.116.16.123.144.151.144.171.137L.189.21z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.173 0 0.654 1",
    fill: "#fff",
    x: 245,
    y: 29,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.622 0.272 0.045 0.069",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.667.312L.622.341l.002-.07.043.041z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0 0.015 1 0.969",
    fill: "#fff",
    x: 238,
    y: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.183 0.871 0.094 0.091",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.225.962L.183.917.265.87c.004.02.017.048.01.063C.269.949.243.953.225.962z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.4 0 0.2 1",
    fill: "#fff",
    x: 235,
    y: 37,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.774 0.035 0.059 0.295",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.809.047L.833.33.773.323.817.035.809.047z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 3,
    viewBox: "0.548 0 0.905 3",
    fill: "#fff",
    x: 250,
    y: 34,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 3,
    viewBox: "0.756 0.975 0.602 1.995",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.935 1.51C.88 1.323.822 1.128 1 .985c.027-.021.097 0 .202.005.005.562.205 1.118.144 1.678-.024.226-.156.328-.415.292l.009.01c-.055-.312-.102-.627-.17-.941-.047-.215.028-.378.164-.524l-.042.122.043-.115z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 3,
    viewBox: "0.676 0 0.647 3",
    fill: "#fff",
    x: 250,
    y: 36,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 3,
    viewBox: "0.742 0.959 0.388 1.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.931.959c.27.49.187.993.189 1.495 0 .082-.091.16-.179.305C.598 2.093.766 1.532.944.973L.93.959z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0 0.28 1 1.441",
    fill: "#fff",
    x: 252,
    y: 28,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 2,
    viewBox: "0.16 0.866 0.132 0.19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.292 1.02l-.108.036C.174 1.006.152.949.163.906.169.88.23.879.267.866l.025.154z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 38,
    viewBox: "0.436 0 15.129 38",
    fill: "#fff",
    x: 216,
    y: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 38,
    viewBox: "0.087 0.275 14.971 37.604",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M15.036 35.129l-.004-.014c0-.053-.004-.105-.011-.157-.016-.108-.314-2.563-.34-2.667-.21-.863-.471-1.678-.465-2.59.002-.327-.163-.651-.26-.97-.104-.35-.276-.681-.318-1.038-.228-1.958-.829-3.686-1.259-5.46-.23-.95-.455-1.896-.594-2.857-.137-.94-.389-1.838-.615-2.759-.166-.678-.367-1.356-.484-2.056-.117-.7-.14-1.421-.468-2.09-.068-.137-.061-.326-.098-.49-.111-.488-.224-.983-.344-1.482-.071-.3-.154-.6-.24-.9-.5-1.768-1.003-3.627-1.509-5.61a1.264 1.264 0 0 0-.265-.538c-.047-.651-.13-1.3-.251-1.941-.032-.165-.184-.288-.346-.321-.01-.013-.016-.028-.027-.041-.124-.133-.296-.178-.466-.217L6.661.827c-.248-.22-.47-.15-.666-.057L5.973.765 5.302.604c-.05-.068-.1-.14-.151-.205-.167.012-.321.05-.478.03-.025-.002-.048-.001-.071 0-.217-.227-.65-.23-.733.169-.321 1.526-.29 3.096-.439 4.64-.091.488-.198.96-.282 1.44-.087.493-.198.967-.281 1.45-.262 1.524-.252 3.108-.72 4.488a.686.686 0 0 0-.046.297c.102.68-.082 1.293-.176 1.903a25.423 25.423 0 0 0-.273 3.228c-.02.78-.069 1.57-.195 2.333-.134.817.003 1.646-.08 2.472-.003.035.002.073-.006.104-.267 1-.212 2.087-.33 3.16-.055.504-.08 1.01-.004 1.532.035.24.019.526-.038.763-.171.726-.21 1.484-.229 2.264-.029 1.16-.136 4.567-.417 5.745-.046.192-.071.397-.097.548.016.06.034.11.053.16v.264a.399.399 0 0 0-.222.266c.017.084.054.158.142.197.138.06.354.004.496-.023.459-.085.908-.166 1.374-.215 1.102-.116 2.21-.188 3.305-.361a.46.46 0 0 0-.01-.153c-.005-.025-.021-.042-.03-.064.053-.033.11-.068.16-.101 0-.427-.021-.748.006-1.059.05-.592.07-3.044.017-3.915.092-.755.18-1.51.232-2.267.214-.036.43-.057.645-.06.658-.012 1.31-.048 1.956-.274a3.76 3.76 0 0 1 .936-.187c.385-.032.504.102.65.579.239.77.333 1.583.35 2.476.015.703.483 3.676.805 4.071.114.054.229.107.343.165.025.012.046.03.069.044a.218.218 0 0 1 .147-.097c.813-.13 1.625-.265 2.444-.335.032.004.064.01.097.013.074.006.152-.01.225-.022a.792.792 0 0 0 .379-.202.686.686 0 0 0 .128-.165c.025-.044.043-.094.062-.142a.753.753 0 0 0 .02-.429zM8.81 23.927a1.939 1.939 0 0 1-.25.243 1.44 1.44 0 0 1-.773.318 2.144 2.144 0 0 1-.526-.014c-.175-.021-.351-.054-.525-.084-.383-.064-.758-.21-1.193-.335-.001-.237-.003-.475-.003-.713-.001-.357.003-.716.021-1.074.019-.358.051-.715.106-1.07.177-1.137.393-2.248.397-3.41 0-.13.009-.268.047-.384.271-.83.206-1.736.273-2.62.042-.553.109-1.105.172-1.66.005-.043.077-.066.163-.135.1.338.199.666.275.997.024.11.046.221.065.333.097.59.167 1.18.26 1.764.036.224.099.444.158.662.06.22.144.432.191.654.343 1.623.686 3.227 1.013 4.855.108.54.212 1.09.129 1.673z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.21 0 0.581 1",
    fill: "#fff",
    x: 222,
    y: 27,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0.89 0.472 0.047 0.081",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M.919.472l.018.08L.89.537C.9.511.907.498.919.472z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 34,
    viewBox: "0.516 0 16.968 34",
    fill: "#fff",
    x: 230,
    y: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 34,
    viewBox: "0.592 0.369 16.651 33.366",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M17.153 30.599h.025c.113-.546.053-1.048.016-1.538-.041-.527-.095-1.038-.14-1.54-.088-.972-.175-1.903-.26-2.802-.059-.638-.136-1.261-.165-1.874-.042-.895-.065-1.761-.245-2.608a1.62 1.62 0 0 1-.031-.4c.04-1.228-.134-2.422-.277-3.638-.055-.47-.01-.947-.002-1.425.003-.21.037-.42.033-.631-.01-.43-.04-.865-.054-1.305-.03-.991.003-2.007-.103-3.071-.079-.798-.154-1.614-.136-2.46.006-.218-.021-.45.006-.664.13-1.032-.203-2.111-.317-3.249-.026-.257-.194-.514-.281-.733l-.51.006a1.03 1.03 0 0 0-.094-.203l-.065-.087a92.02 92.02 0 0 0-1.19-.27 5.414 5.414 0 0 0-.246-.046c-.011.003-.022.003-.033.005l-.011-.013c-.461-.076-.928-.107-1.384-.196a.645.645 0 0 0-.108.183c-.04.104-.064.22-.074.339-.031.02-.063.04-.093.067a.543.543 0 0 0-.061-.183l-.074-.043c-.059.21-.147.394-.265.53a.83.83 0 0 1 .019.199c-.055.115-.1.241-.132.379-.096.252-.14.533-.132.839l.022.24a20.077 20.077 0 0 0-.311 3.01c-.007.286-.04.565-.059.843-.094 1.267-.354 2.426-.421 3.62-.04.692-.185 1.353-.295 2.015-.025.15-.035.353-.271.32-.04-.087-.097-.184-.132-.291-.28-.85-.557-1.716-.829-2.611-.306-1.011-.561-2.083-1.027-3.093-.346-.75-.58-1.576-.854-2.408-.338-1.024-.582-2.143-1.073-3.165a.672.672 0 0 1-.031-.523 1.99 1.99 0 0 1-.315-.567c-.069.066-.14.14-.216.21-.24-.56-.56-.727-.953-.693-.143.014-.296-.076-.45-.16C2.787.836 2.023.737 1.284.517 1.054.25.565.34.593.805c.399 6.64.896 13.285 1.039 19.938a.439.439 0 0 0 .164.352c.084.878.194 1.756.28 2.633.125 1.29.184 2.583.197 3.882.01.934.004 1.87.005 2.805.011.055.02.113.035.166 0 .434.004 1.21.07 1.614.029.18.077.337.137.473.002.02-.002.04 0 .06.011.086.018.176.027.264a.412.412 0 0 0-.12.413c.059.209.321.397.543.307.009-.003.018-.005.027-.01.037.009.074.018.113.017.19-.005.392-.063.58-.097a30.039 30.039 0 0 0 1.505-.32c.062 0 .123-.004.185-.002.404.012.9.034 1.26-.184.326-.195.38-.575.347-.936a.449.449 0 0 0 .029-.163c-.008-.411-.011-1.152-.02-1.564 0-.04-.012-.071-.02-.107a2.68 2.68 0 0 0-.051-1.036c-.223-.875-.258-1.76-.31-2.622a14.71 14.71 0 0 0-.13-1.265c-.164-1.104-.361-2.167-.47-3.225.073-.687.154-1.368.172-2.056.09.16.166.336.238.514.306.754.603 1.52.917 2.282.168.405.367.79.518 1.116.329.19.591.119.855.082.526-.072 1.053-.155 1.583-.198.286-.023.506-.182.71-.397.238-.248.046-1.281.28-1.53l.741-2.425c-.013-.304.35-.573.38-.87.015-.144.05-.275.114-.397-.018.25-.021.504-.016.755-.081 1.459-.03 2.965-.005 4.538.034 2.127.114 4.401.335 6.927.015.167.058.303.116.417 0 .084-.005.168-.002.251.004.095.009.189.016.283.009.118.013.247.039.36.007.032.02.059.031.089l-.006.069c-.024.16-.007.308.113.429.103.102.287.168.429.113a9.075 9.075 0 0 1 2.199-.566 9.44 9.44 0 0 1 .557-.05c.204-.011.423.004.603-.11.36-.23.346-.725.214-1.095a1.15 1.15 0 0 0 .007-.13z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    viewBox: "0 0.062 16 28.875",
    fill: "#fff",
    x: 249,
    y: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    viewBox: "0.271 0.368 15.72 28.371",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M15.268 23.947a51.898 51.898 0 0 0-1.464-5.641c-.62-1.961-1.287-3.907-1.93-5.86-.637-1.941-1.25-3.892-1.785-5.868-.426-1.571-.84-3.153-1.382-4.686a11.668 11.668 0 0 0-.876-.405c-.5-.213-.998-.43-1.495-.645C5.932.665 5.514.469 5.122.52a.421.421 0 0 0-.193.006l-.06.01a3.429 3.429 0 0 1-.657.02c-.01-.001-.02.002-.031.002a.429.429 0 0 0-.297-.19 8.32 8.32 0 0 1-.129.54.297.297 0 0 1-.213.21c-.195 1.597-.683 3.169-.911 4.752-.051.355-.095.71-.14 1.066-.006.14-.01.286-.019.424a13.693 13.693 0 0 1-.221 1.789c-.006.03-.017.056-.024.085-.095.892-.188 1.785-.297 2.676-.24 1.967-.518 3.928-.751 5.896a78.34 78.34 0 0 0-.473 5.828c-.036.839-.075 1.68-.144 2.518-.003.076-.002.15-.006.227-.015.347-.034.572-.016.747l-.04.129-.111.374c-.035.114-.078.228-.101.345-.042.22-.009.45.158.606.147.139.336.173.528.154.239-.023.467-.09.678-.207l.009.004c.22.055.44.026.656-.04l.702-.036c.52-.027 1.255.037 1.446-.586.002-.01 0-.02.002-.028l.001-.004.003-.003.003-.006c.018-.035.041-.08.05-.121.005-.021.006-.05.009-.066.002-.017.008-.045.008-.067v-.01-.006l-.015-.107c.152-.213.216-.5.172-.796-.246-1.665.002-3.14.273-4.542l.028-.142c.018-.023.037-.045.054-.07.833-.235 1.663-.48 2.554-.345.61-.154 1.26.058 1.869-.155.092-.032.26-.032.311.023.175.189.388.184.609.189.264.006.402.158.466.388.253.907.547 1.84.65 2.877.024.236.089.469.114.711.032.306.125.574.255.819.053.408.152.804.313 1.184l.03.068c1.207-.281 2.47-.277 3.677-.55.03-.01.06-.02.09-.028-.295-1.027-.515-2.081-.723-3.135zm-6.734-6.98c-.003.063-.06.12-.114.224-.69-.02-1.391-.037-2.091-.058a11.31 11.31 0 0 1-.731-.045c-.192-.017-.301-.136-.301-.294 0-.19.033-.378.069-.561v-.001c.1-.504.386-.962.298-1.498-.007-.042.017-.09.04-.13l.017-.035c.432-.795.479-1.66.529-2.54.007-.128.014-.256.023-.385.034-.513.128-1.024.202-1.546.035-.25.089-.494.166-.92.125.452.19.714.277.972.08.24.182.475.275.709v.004c.01.023.021.046.019.067-.04.609.235 1.186.386 1.763l.015.054c.023.092.019.19.065.275.398.71.387 1.446.55 2.168.098.43.205.859.291 1.293.015.077.021.156.022.234 0 .084-.002.167-.007.25zm2.287-6.826c-.01.042-.119.087-.173.074-.055-.013-.144-.106-.14-.147.023-.173.073-.341.114-.512a.555.555 0 0 1 .199.585z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 46,
    viewBox: "0.281 0 18.437 46",
    x: 169,
    y: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 46,
    viewBox: "0.673 0.957 17.66 44.061",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M18.334 32.544a.624.624 0 0 0-.247-.133c-.41-.11-.85-.297-1.237-.22-.513.103-.983-.061-1.473-.12-.938-.112-1.872-.498-2.828-.183-.187.06-.425-.051-.643-.101-.022.023-.047.043-.066.068a4.291 4.291 0 0 0-.132.19c.097.52.129 1.06.131 1.583.002.58-.033 1.193-.203 1.757-.013.557-.19 1.067-.434 1.53-.173.327-.358.509-.565.566a.64.64 0 0 1-.307.212c-.432.133-.892-.192-1.17-.492a1.929 1.929 0 0 1-.47-.822c-.318-.253-.446-.614-.444-1.09 0-.705-.01-1.406-.039-2.103-.053-1.26-.136-2.506-.183-3.742-.086-2.267-.139-4.504-.422-6.717a7.636 7.636 0 0 1-.034-1.131c.031-1.432.022-2.86-.223-4.278-.238-1.371-.232-2.751-.038-4.192.152-1.133.828-1.875 1.372-2.725.338-.526.905-.37 1.117.194.901.817.983 2.324 1.003 3.448.005.296-.003.59-.015.885.003.039.005.079.009.118.052.603.08 1.21.105 1.817a1.3 1.3 0 0 1 .561.305c.011.01.015.024.023.035l.089.007c1.667.168 3.343.255 5.02.267.145 0 .223-.08.243-.173.099-.012.186-.08.183-.207l-.014-.478c.104-.404.2-.777.3-1.172-.006-.142-.008-.283-.013-.425-.29-.657-.284-1.39-.166-2.22.143-1.006.162-2.103-.142-3.07-.462-1.473-.747-3.028-1.275-4.501a7.463 7.463 0 0 0-.353-.818c-.015-.011-.031-.016-.046-.031-.662-.684-1.321-1.381-2.07-1.971-.642-.504-1.36-.89-2.111-1.201-.118.002-.231 0-.341-.009-.491-.047-.98-.108-1.464-.2-.887-.17-1.731.18-2.576.554-.146.064-.35.137-.41.274-.214.479-.598.564-.937.766-.141.084-.31.169-.4.31-.434.68-.948 1.326-1.24 2.062a8.102 8.102 0 0 1-.927 1.716c-.393.56-1.386 3.457-1.464 4.144-.133 1.18-.342 2.335-.377 3.493-.028.903-.08 1.805-.203 2.689-.135.982-.162 1.95-.019 2.9.253 1.683.198 3.366.12 5.058-.028.636-.144 1.27.102 1.918.092.24-.003.554-.02.835-.064 1.129-.267 2.256.051 3.422.055.199.07.416.063.62-.03.696-.11 1.393.338 2.048.064.094.044.248.068.374.114.586.181 1.19.356 1.77.58 1.922 1.29 3.81 2.682 5.453 1.284 1.517 2.707 2.632 4.376 3.288.467.183.905.419 1.314 0 .038-.04.192-.008.203.025.195.584.42.135.63.11.405-.046.808-.121 1.215-.147a.245.245 0 0 1 .234-.118c.603.033 1.156-.152 1.653-.451.14-.093.282-.19.422-.287a5.898 5.898 0 0 0 .956-.947.26.26 0 0 1 .039-.133c.183-.294.413-.552.632-.82.7-1.153 1.143-2.47 1.445-3.779a26.08 26.08 0 0 0 .535-3.264 13.03 13.03 0 0 1 .15-2.34zm-7.166-15.79c-.041-.042-.023-.211-.009-.327.066.127.142.236.23.325-.05-.002-.222 0-.221.002zm3.548.232l-.531-.022c.18-.011.357-.004.531.022zM12.975 3.884c-.021.013-.042.022-.065.04l.094.289-.094-.29c.023-.017.044-.026.065-.04z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 43,
    viewBox: "0.463 0 20.074 43",
    x: 147,
    y: 15,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 43,
    viewBox: "0.514 0.163 19.686 42.168",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M20.106 41.023c.013-1.184-.498-3.35-.262-4.493.037-.18-.045-.41-.053-.613-.011-.285-.053-.59.005-.845.239-1.055.106-2.143.079-3.2-.047-1.855-.181-3.671-.157-5.456.018-1.359-.212-2.712.042-4.057.06-.32-.011-.676-.031-1.014-.041-.712-.094-1.423-.131-2.135-.082-1.538-.16-3.08-.236-4.638-.012-.264-.04-.538-.001-.8.115-.773.08-1.535.018-2.312-.063-.804-.204-1.604-.095-2.458.034-.27.014-.572-.05-.826-.196-.77-.164-1.57-.11-2.403.041-.65.041-1.306.036-1.968.076-.206.053-.51.062-.675.03-.493.027-.989-.011-1.482-.011-.151-.031-.301-.049-.451.033-.101.06-.203.072-.312a1.236 1.236 0 0 0-.017-.377.218.218 0 0 0-.108-.221C19.084.26 19.06.23 19.027.213a.407.407 0 0 0-.28-.042.596.596 0 0 0-.264.129c-.197 0-.402.036-.553.067-.43.087-.84.25-1.268.348-.444.102-.897.16-1.348.22-.85.116-1.691.248-2.465.638a.185.185 0 0 0-.105.215c-.056.054-.09.133-.063.212.02.057.032.116.042.176.008.075.008.15 0 .226a1.127 1.127 0 0 1-.046.189c-.003.006-.001.014-.002.02l-.035.01c-.1 1.043-.217 2.009.003 2.929.069.29.04.626.057.937.014.229.027.456.046.682.026.3.075.595.08.894.012.537-.036 1.079-.001 1.6.077 1.159.023 2.303-.045 3.432-.053.88-.07 1.74.173 2.57.074.254.068.562.034.838-.15 1.217-.128 2.396.127 3.567-.274-.086-.372-.34-.466-.602a362.504 362.504 0 0 0-1.088-3.012c-.237-.643-.524-1.258-.609-1.974-.028-.237-.159-.452-.239-.68-.398-1.135-.816-2.265-1.189-3.433-.385-1.204-.808-2.4-1.333-3.554-.38-.832-.761-1.671-1.138-2.531a2.254 2.254 0 0 0-.552-.79c-.086-.205-.17-.412-.265-.613-.081-.173-.191-.311-.392-.338-.225-.03-.485.039-.71.073-.288.042-.576.09-.863.144-1.111.2-2.216.445-3.347.505a.214.214 0 0 0-.206.187c-.052.049-.11.114-.2.195l-.003.006.114.059a.187.187 0 0 0-.078.17l.071 1.59.007.067c.108.966.183 1.933.217 2.908.047 1.383.007 2.769.051 4.152.037 1.157.13 2.325-.062 3.47.004.107.015.213.019.319a.202.202 0 0 0-.068.158v.768a12.68 12.68 0 0 0 0 1.443v20.038a.292.292 0 0 1 .046.146c-.001.035-.006.07-.01.106a5.241 5.241 0 0 1-.09.569c.023.034.042.07.073.097a.77.77 0 0 0 .122.079c.105.16.29.279.482.324.406.096.827.149 1.243.215.317.215.69.337 1.198.398.389.047.795.164 1.168.08.433.094.865.187 1.298.279.169.036.277-.11.274-.24a.542.542 0 0 0 .232-.055c.057-.03.112-.064.223-.128l.052-.922c-.095-.632-.157-2.882-.136-3.52.001-.017.005-.032.006-.048-.224-.958-.252-1.862-.025-2.772.143-.574.114-1.217.135-1.823.017-.501-.078-1.021 0-1.493.056-.334.08-.666.09-.997-.053-.925-.136-1.847-.152-2.774-.023-1.248.016-2.496-.05-3.742-.006-.1.03-.17.086-.217-.014-.083-.022-.168-.039-.251a.323.323 0 0 1 0-.098 2.339 2.339 0 0 1-.118-.327c-.045-.171.045-.332.218-.4.172-.066.322-.005.419.149.05.08.106.192.09.276-.021.106-.03.208-.03.307.033.171.06.344.087.516.072.203.185.394.335.578.079.097.11.247.138.378.147.732.24 1.485.707 2.123.054.075.053.198.07.299.256 1.405.743 2.775 1.178 4.207.308 1.012.626 2.044.945 3.103.166.548.334 1.102.509 1.66.117.374.31.743.359 1.124.139 1.106.473 3.19.771 4.316.226.854.644 1.304 1.305 1.429.52.098 1.049.152 1.56.335.624.224 1.23.269 1.844.245.48-.02.963-.022 1.438-.07.513-.05 1.012-.166 1.364-.784-.027-.123-.096-.292-.094-.45zM5.64 3.088a7.152 7.152 0 0 0-.286-.07.96.96 0 0 1 .301-.027.189.189 0 0 0-.015.097zm7.471 17.32l-.008-.015c-.02-.026-.044-.05-.066-.075.006-.075.049-.15.08-.225l-.006.315zm2.726-18.567c-.153.016-.306.029-.46.045a.23.23 0 0 0 .024-.062c.154-.02.304-.056.45-.105a.233.233 0 0 0-.014.122zm1.219-.272h-.02l.021-.011-.001.01zm1.74 1.093l-.004-.004c.002-.007.005-.012.005-.02v.024z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 37,
    viewBox: "0.47 0 15.06 37",
    x: 130,
    y: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 37,
    viewBox: "0.601 0.649 14.481 35.577",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M15.082 9.281c-.011-.271-.018-.543-.027-.814a3.879 3.879 0 0 1-.021-.631c-.023-.84-.038-1.68-.045-2.52a.317.317 0 0 0-.015-.04 16.976 16.976 0 0 0-.061-1.532c-.008-.077-.02-.154-.028-.232a3.175 3.175 0 0 0-.056-.463c-.056-.421-.112-.842-.12-1.267a.263.263 0 0 1 .005-.258c.002-.038 0-.077.002-.116a.208.208 0 0 0-.019-.1l.005-.257c.002-.097-.061-.17-.144-.202-.002-.133-.156-.226-.275-.193-.295.084-.588.175-.88.27-.24-.065-.512-.054-.821.063-.221.084-.453.1-.68.147-.619.127-1.238.239-1.854.38-.006.013-.01.027-.018.043l-.009.018a.671.671 0 0 1-.05.065c-.007.008-.017.013-.026.02-.022 1.213.015 2.428-.015 3.641-.025 1.019-.068 2.037-.108 3.055-.01.259-.024.518-.035.778.06.377.013.767-.006 1.149.002.106.001.213-.002.318.003.093.012.184.025.274l-.001.004c-.02.363-.006.726.025 1.088-.127.663-.28 1.312-.22 1.966.017.19-.071.426-.19.599a2.628 2.628 0 0 1-.51.553c-.263.15-.554.172-.856.13-.547-.078-1.076-.352-1.375-.827l-.005-.08a.234.234 0 0 0-.09-.171 3.53 3.53 0 0 0-.163-.881c-.372-1.093-.443-2.268-.438-3.48.005-1.384-.291-2.775-.16-4.335.024-.276-.07-.547-.082-.83a2.598 2.598 0 0 0-.055-.42l-.02-.642-.017-.534c-.004-.134.018-.311-.034-.44-.055-.135-.187-.18-.336-.188-.385.049-.768.099-1.15.15h-.001a1.317 1.317 0 0 0-.068.01l-.073.009-.012.002c-.32.043-.64.088-.958.134a7.118 7.118 0 0 1-.11.065l-.069-.038c-.373.055-.748.114-1.123.176l-.06.07-.042-.053c-.171.028-.342.055-.514.086l-.061.138c-.044.01-.09.02-.13.04a.441.441 0 0 0-.231.26c-.04.116.028.296-.028.394a.201.201 0 0 0 .004.214.86.86 0 0 0-.049.298c.065 1.188.043 2.335.215 3.377.176 1.07.133 2.103.085 3.108-.021.413-.042.824-.005 1.218.089.932.247 1.829.298 2.728.027.478.101.907.408 1.3.133.174.139.432.302.573.53.457 1.016.948 1.453 1.487.293.362.645.67 1.213.79.559.118.802.536.72.99-.098.553-.008 1.09.052 1.637a5.06 5.06 0 0 1-.081 1.661c-.086.388-.043.77-.028 1.164.015.392.002.789.005 1.192.003.279-.029.565.028.844.104.504.114 1.01.127 1.533.037 1.513.06 3.922-.152 5.586.034.082.058.17.088.253-.033.453-.001.909.096 1.353-.094.1-.07.283.059.348a.23.23 0 0 0 .155.087l3.728.458.918.113c.268.033.565.107.834.074a.59.59 0 0 0 .252-.094c.129.08.343.024.343-.175l.001-.575a.237.237 0 0 0 .009-.297c.049-3.417-.025-6.836-.22-10.247.014-.023.025-.046.04-.068a3.265 3.265 0 0 0-.058-.192c-.037-.631-.084-1.261-.129-1.892a25.63 25.63 0 0 1 .02-1.715c.006-.098.023-.191.039-.284-.008-.355-.037-.715.034-1.066.014-.07.041-.134.066-.2-.003-.03-.006-.06.004-.09a.51.51 0 0 1 .112-.193l.014-.013.052-.04c.112-.15.25-.28.403-.394.388-.291.773-.565 1.116-.91.188-.19.36-.39.527-.596.104-.27.184-.548.239-.834.13-.684.319-1.355.518-2.033.32-1.097.583-2.224.547-3.394-.016-.54-.168-1.071.033-1.635zm-3.93 18.498c.017-.062.028-.127.037-.192.003.074.008.148.01.222-.012-.012-.029-.02-.046-.03z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0.71 15 28.58",
    x: 115,
    y: 22,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0.067 0.851 14.873 28.338",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M14.94 20.603c-.014-.613-.056-1.213-.054-1.8.002-.452-.027-.882-.175-1.317a3.379 3.379 0 0 1-.178-1.441c.068-.692.028-1.39-.425-2a2.236 2.236 0 0 1-.29-.491c-.211-.543-.766-.842-1.332-1.042-.602-.211-1.297-.285-1.966-.355-.508-.052-1.042.005-1.56-.015-.61-.024-1.226-.047-1.82-.124-1.504-.196-2.226-1.058-2.003-2.043.044-.195.024-.399.02-.598-.022-.884.07-1.797.315-2.766.069-.273.159-.56.307-.824.218-.387.693-.518 1.01-.341.864.29 1.17 1.307 1.26 2.123.033.283.039.606.01.928.046.382.064.767.068 1.149.22.257.41.539.544.832.237.517.791.572 1.378.603.222.014.469-.065.676-.028.874.16 1.732-.056 2.62-.163.062-.16.148-.29.151-.414.019-.615 0-1.236.019-1.873s-.358-1.218-.183-1.913c.013-.052-.033-.108-.046-.163-.19-.776-.379-1.574-.578-2.398-.043-.176-.068-.371-.164-.515-.626-.938-1.403-1.786-2.451-2.306-.607-.3-1.281-.062-1.878-.408-.023-.014-.05-.022-.076-.032-.127-.01-.255-.02-.382-.017a4.4 4.4 0 0 0-.314.018l-.12.013-.072.01c-.852.164-1.489-.003-2.209.386a.953.953 0 0 1-.192.07c-.44.232-.892.43-1.319.677-.315.18-.631.394-.89.646a4.706 4.706 0 0 0-1.343 2.47 4.778 4.778 0 0 1-.297.904c-.4.953-.842 1.853-.575 2.75.038.129-.01.297-.079.431-.237.46-.24.904-.203 1.346.015.184.053.375 0 .553-.142.467-.064.897.054 1.32a.821.821 0 0 1 .178.298c.019.06.035.15.072.202l-.035-.083.044.098c.063.14.126.28.184.425.05.124.09.253.116.387.294.21.43.482.534.777.042.12.172.246.314.322.349.19.7.403 1.103.526.55.168 1.152.256 1.598.59.061.045.175.058.268.072.598.095 1.199.18 1.8.283.851.143 1.737.184 2.545.503.387.153.61.352.653.707.073.596.203 1.202.281 1.827a.956.956 0 0 1-.067.45c-.091.384-.154.77-.265 1.148-.115.388-.272.796-.562 1.089-.304.305-.761.42-1.17.27-.501-.182-.811-.642-1.015-1.142a1.644 1.644 0 0 1-.358-.677c-.177-.676-.365-1.322-.467-1.964-.117-.736-.766-1.156-1.678-1.078-.894.078-1.776.224-2.655.35-.43.062-.653.28-.688.615-.008.073-.009.149-.02.222-.13.878.244 1.767.349 2.729.032.29.228.58.159.908a.52.52 0 0 0 .059.335c.32.58.56 1.219 1.06 1.773.323.359.554.808.805 1.246.037.064.024.156.013.252.059.039.119.073.177.116.334.234.54.525.649.835l.079-.03c.364.25.724.459 1.038.737.339.299.636.663 1.002 1.065.184.06.447.123.697.234 1.014.452 2.012.32 3.014.267.219-.013.436-.12.625-.235.283-.174.56-.357.836-.542.197-.225.42-.42.663-.606.135-.103.276-.198.42-.286.09-.121.18-.241.268-.364l.02-.1c-.003-.032-.022-.08-.007-.096.429-.555 1.008-.996 1.087-1.77.612-.511.672-1.194.647-1.955-.024-.708.205-1.383.32-2.05.03-.173.056-.347.052-.522z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-day.2dba1f4d.svg";
export { ForwardRef as ReactComponent };